/**
 * Public server function exposing live catalogue pricing to route loaders.
 * Read-only, no auth: the same prices are already visible on the storefront.
 */
import { createServerFn } from "@tanstack/react-start";
import type { CatalogPricing } from "@/lib/pricing/catalog-pricing.server";

export const getCatalogPricing = createServerFn({ method: "GET" }).handler(
  async (): Promise<CatalogPricing> => {
    const { loadCatalogPricing } = await import(
      "@/lib/pricing/catalog-pricing.server"
    );
    return loadCatalogPricing();
  },
);
